export const FieldNames = {
  ampCompromised: "ampCompromised",
  ampConnectorGUID: "ampConnectorGUID",
  ampDefinitions: "ampDefinitions",
  ampIsolation: "ampIsolation",
  ampOrbital: "ampOrbital",
  appUsers: "appUsers",
  application: "application",
  assets: "assets",
  assetMappings: "asset-mappings",
  assignees: "assignees",
  attackPattern: "attack-pattern",
  attackPatterns: "attack_patterns",
  autoTags: "autoTags",
  casebooks: "casebooks",
  categories: "categories",
  completedActionIds: "completed-action-ids",
  computerSID: "computerSid",
  confidence: "confidence",
  context: "context",
  created: "created",
  createDate: "create_date",
  currentSessionActionId: "current-action-id",
  currentSessionStatus: "current-session-status",
  cves: "cves",
  cvesCount: "cvesCount",
  cvss: "cvss",
  cvssScoreTallies: "cvssScoreTallies",
  demoId: "demoId",
  description: "description",
  discoveryMethod: "discovery_method",
  disposition: "disposition",
  dispositionName: "disposition_name",
  duplicateOf: "duplicate-of",
  emails: "emails",
  endTime: "end_time",
  enrichmentStatus: "enrichment_status",
  events: "events",
  externalId: "external_id",
  externalReferences: "external_references",
  faults: "faults",
  feedViewUrl: "feed_view_url",
  fileName: "fileName",
  groups: "groups",
  hashes: "hashes",
  id: "id",
  idempotent: "idempotent",
  incidentEnrichmentId: "incident-id",
  incidentEnrichmentIds: "incident-ids",
  incidentTime: "incident_time",
  incidentTimeOpened: "incident_time.opened",
  indicator: "indicator",
  indicatorType: "indicator_type",
  indicators: "indicators",
  intendedEffect: "intended_effect",
  internal: "internal",
  investigate: "investigate",
  investigationId: "investigationId",
  investigations: "investigations",
  investigationShortDescription: "investigationShortDescription",
  judgement: "judgement",
  judgements: "judgements",
  judgementId: "judgement_id",
  killChainPhases: "kill_chain_phases",
  lastUpdated: "lastUpdated",
  lifetime: "lifetime",
  likelyImpact: "likely_impact",
  link: "link",
  malware: "malware",
  malwares: "malwares",
  managed: "managed",
  maxCVSSScore: "maxCVSSScore",
  message: "message",
  mitreData: "mitreData",
  modelIdentifier: "modelIdentifier",
  module: "module",
  name: "name",
  notable: "notable",
  observable: "observable",
  observables: "observables",
  observableType: "observableType",
  observedTime: "observed_time",
  opened: "opened",
  osType: "osType",
  osTypeVersionBuild: "osTypeVersionBuild",
  output: "output",
  overview: "overview",
  owner: "owner",
  ownerName: "owner_name",
  pendingActionIds: "pending-action-ids",
  phaseName: "phase_name",
  policyName: "policyName",
  priority: "priority",
  producer: "producer",
  rating: "rating",
  reason: "reason",
  relatedIncidents: "relatedIncidents",
  relations: "relations",
  relationship: "relationship",
  relationshipTargetType: "relationshipTargetType",
  relationshipType: "relationship_type",
  relationships: "relationships",
  resolution: "resolution",
  resolveAsset: "resolve-asset",
  revision: "revision",
  scores: "scores",
  scoresGlobal: "scores.global",
  searchTxt: "search-txt",
  sensor: "sensor",
  sensorCoordinates: "sensor_coordinates",
  sessionId: "session-id",
  severity: "severity",
  shortDescription: "short_description",
  short_id: "short_id",
  sighting: "sighting",
  sightings: "sightings",
  software: "software",
  source: "source",
  sourceName: "source_name",
  sourceRef: "source_ref",
  sourceURI: "source_uri",
  startTime: "start_time",
  status: "status",
  tactics: "tactics",
  tagCount: "tagCount",
  tags: "tags",
  target: "target",
  targets: "targets",
  timestamp: "timestamp",
  title: "title",
  tlp: "tlp",
  tool: "tool",
  tools: "tools",
  type: "type",
  umbrellaClientTypeVersion: "umbrellaClientTypeVersion",
  url: "url",
  user: "user",
  userEmail: "user-email",
  userId: "user-id",
  userName: "user-name",
  userNick: "user-nick",
  userPhone: "user-phone",
  users: "users",
  validTime: "valid_time",
  value: "value",
  verdict: "verdict",
  version: "version",
  vulnerabilities: "vulnerabilities",
  vulnerability: "vulnerability"
};
